<div id="review" *ngIf="timecardReview">
    <h3 *ngIf="!reviewGridLoading" style="display: flow-root;">
        Review {{reviewGrid?.timecard.EmployeeFullName}}'s timecard
        <button *ngIf="isStandardTimecard" class="btn btn-outline-dark float-right" (click)="cancelReview()">Cancel</button>
    </h3>
    <hr />
    <div *ngIf="reviewGrid?.alert" class="row">
        <div class="col-lg-12">
            <div class="alert alert-{{reviewGrid?.alert.type}}" role="alert">
                {{reviewGrid?.alert.msg}}
            </div>
        </div>
    </div>
    <div class="partial-screen-overlay-container" style="min-height: 100px;">
        <div *ngIf="reviewGridLoading">
            <div class="partial-screen-overlay"></div>
            <div class="partial-screen-overlay-text" style="line-height: 32px;">
                <img src="/Cache/images/icon_load.gif" alt="Loading..." style="float:left;" />
                <div style="float:left; margin-left: 12px;">Please wait while your timecard is loading...</div>
            </div>
        </div>
        <div *ngIf="!reviewGridLoading">
            <div [ngClass]="{'row': ((!isStandardTimecard && (reviewGrid.timecard.CrewTemplateID !== null && crewSettings.IsTimeWorkedEnabled) || (reviewGrid.timecard.CrewTemplateID === null && standardSettings.IsTimeWorkedEnabled)) || (isStandardTimecard && timecard.IsTimeWorkedEnabled))}">
                <!-- Hours By Earn Code -->
                <div *ngIf="reviewGrid.totals != null" [ngClass]="{'col-lg-6 col-md-6': ((!isStandardTimecard && (reviewGrid.timecard.CrewTemplateID !== null && crewSettings.IsTimeWorkedEnabled) || (reviewGrid.timecard.CrewTemplateID === null && standardSettings.IsTimeWorkedEnabled)) || (isStandardTimecard && timecard.IsTimeWorkedEnabled))}">
                    <div class="card border mb-3">
                        <div class="card-header bg-light">
                            Hours By Earn Code
                        </div>
                        <div class="card-body">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="rotatedHeader tableHeader"><div><span></span></div></th>
                                        <th *ngFor="let earnCode of reviewGrid.earnCodes" class="rotatedHeader tableHeader">
                                            <div>
                                                <span>{{earnCode.DisplayName}}</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="reviewGrid.hours['J'].Total != 0 || reviewGrid.expenses['J'].Expenses != 0">
                                        <td>Job Hours</td>
                                        <td *ngFor="let earnCode of reviewGrid.earnCodes">
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['J'][earnCode.Value] != null">
                                                {{reviewGrid.hours['J'][earnCode.Value]}}
                                            </span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.expenses['J'][earnCode.Value] != null">
                                                {{reviewGrid.expenses['J'][earnCode.Value] | currency:currencySymbol}}
                                            </span>
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['J'][earnCode.Value] == null && reviewGrid.expenses['J'][earnCode.Value] == null">0.00</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.hours['J'][earnCode.Value] == null && reviewGrid.expenses['J'][earnCode.Value] == null">{{currencySymbol}}0.00</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="reviewGrid.hours['O'].Total != 0 || reviewGrid.expenses['O'].Expenses != 0">
                                        <td>{{unbilledLabel}} Hours</td>
                                        <td *ngFor="let earnCode of reviewGrid.earnCodes">
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['O'][earnCode.Value] != null">{{reviewGrid.hours['O'][earnCode.Value]}}</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.expenses['O'][earnCode.Value] != null">{{reviewGrid.expenses['O'][earnCode.Value] | currency:currencySymbol}}</span>
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['O'][earnCode.Value] == null && reviewGrid.expenses['O'][earnCode.Value] == null">0.00</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.hours['O'][earnCode.Value] == null && reviewGrid.expenses['O'][earnCode.Value] == null">{{currencySymbol}}0.00</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="reviewGrid.hours['S'].Total != 0 || reviewGrid.expenses['S'].Expenses != '0.00'">
                                        <td>Service Hours</td>
                                        <td *ngFor="let earnCode of reviewGrid.earnCodes">
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['S'][earnCode.Value] != null">{{reviewGrid.hours['S'][earnCode.Value]}}</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.expenses['S'][earnCode.Value] != null">{{reviewGrid.expenses['S'][earnCode.Value] | currency:currencySymbol}}</span>
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['S'][earnCode.Value] == null && reviewGrid.expenses['S'][earnCode.Value] == null">0.00</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.hours['S'][earnCode.Value] == null && reviewGrid.expenses['S'][earnCode.Value] == null">{{currencySymbol}}0.00</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="reviewGrid.hours['M'].Total != 0 || reviewGrid.expenses['M'].Expenses != 0">
                                        <td>Mechanic Hours</td>
                                        <td *ngFor="let earnCode of reviewGrid.earnCodes">
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['M'][earnCode.Value] != null">{{reviewGrid.hours['M'][earnCode.Value]}}</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.expenses['M'][earnCode.Value] != null">{{reviewGrid.expenses['M'][earnCode.Value] | currency:currencySymbol}}</span>
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.hours['M'][earnCode.Value] == null && reviewGrid.expenses['M'][earnCode.Value] == null">0.00</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.hours['M'][earnCode.Value] == null && reviewGrid.expenses['M'][earnCode.Value] == null">{{currencySymbol}}0.00</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Total Hours</td>
                                        <td *ngFor="let earnCode of reviewGrid.earnCodes">
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.totals[earnCode.Value] != null">{{reviewGrid.totals[earnCode.Value]}}</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.totals[earnCode.Value] != null">{{reviewGrid.totals[earnCode.Value] | currency:currencySymbol}}</span>
                                            <span *ngIf="earnCode.Type == 'H' && reviewGrid.totals[earnCode.Value] == null">0.00</span>
                                            <span *ngIf="earnCode.Type == 'E' && reviewGrid.totals[earnCode.Value] == null">{{currencySymbol}}0.00</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- Review Clock In / Clock Out Times -->
                <div class="col-lg-6 col-md-6" *ngIf="((!isStandardTimecard && (reviewGrid.timecard.CrewTemplateID !== null && crewSettings.IsTimeWorkedEnabled) || (reviewGrid.timecard.CrewTemplateID === null && standardSettings.IsTimeWorkedEnabled)) || (isStandardTimecard && timecard.IsTimeWorkedEnabled))">
                    <div id="reviewTimeWorked" class="card border mb-3">
                        <div class="card-header bg-light">
                            Review Clock In / Clock Out Times
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12" style="margin-bottom:12px;">
                                    <ng-select [(ngModel)]="selectedWeek"
                                               name="Week"
                                               [items]="weeks"
                                               (change)="getDailyTime()"
                                               bindLabel="DisplayValue"
                                               [clearable]="false"
                                               dropdownPosition="bottom"
                                               [disabled]="!dailyTimeLoaded">
                                    </ng-select>
                                </div>
                                <div class="d-block d-md-none col-md-6 col-sm-12" style="margin-bottom:12px;">
                                    <ng-select [(ngModel)]="selectedDay"
                                               name="DaysOfWeek"
                                               [items]="daysOfWeek"
                                               bindLabel="Day"
                                               [clearable]="false"
                                               dropdownPosition="bottom"
                                               (ngModelChange)="dayChanged()"
                                               [disabled]="!dailyTimeLoaded">
                                    </ng-select>
                                </div>
                            </div>
                            <div class="row d-block d-lg-none" style="margin-top: 12px;" *ngIf="selectedDay != null">
                                <div class="d-none d-md-block d-lg-none col-md-6 col-sm-6">
                                    <label><strong>Subtotal:</strong></label> {{timeWorkedSubTotals[selectedDay?.DayNumber]?.Subtotal}}
                                    <ng-template #popContent><div [innerHtml]="timeWorkedSubTotals[selectedDay?.DayNumber]?.Text"></div></ng-template>
                                    <span *ngIf="timeWorkedSubTotals[selectedDay?.DayNumber]?.Difference != 0" class="btn"
                                          [ngClass]="{'btn-outline-dark' : timeWorkedSubTotals[selectedDay?.DayNumber]?.DifferenceAbs <= gpsClockInFaultTolerance, 'btn-danger' : timeWorkedSubTotals[selectedDay?.DayNumber]?.DifferenceAbs > gpsClockInFaultTolerance }"
                                          [ngbPopover]="popContent"
                                          [autoClose]="'inside'">
                                        ({{timeWorkedSubTotals[selectedDay?.DayNumber]?.Difference}})
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="partial-screen-overlay-container">
                                        <div *ngIf="!dailyTimeLoaded">
                                            <div class="partial-screen-overlay"></div>
                                            <div class="partial-screen-overlay-text" style="line-height: 32px;">
                                                <img src="/Cache/images/icon_load.gif" alt="Loading..." style="float:left;" />
                                                <div style="float:left; margin-left: 12px;">Please wait while your daily time is loading...</div>
                                            </div>
                                        </div>
                                        <!--Desktop Time In/Out-->
                                        <div class="row d-none d-md-block" *ngIf="dailyTimeLoaded" style="overflow-x: auto;">
                                            <table class="table col-lg-12">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th class="tableHeader" *ngFor="let day of daysOfWeek">
                                                            {{day.Day}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngIf="isStandardTimecard">
                                                        <td>Notes</td>
                                                        <td *ngFor="let day of daysOfWeek">
                                                            <button type="button" class="btn btn-outline-dark btn-icon-only" (click)="getNotes(day,true)" *ngIf="hasTime[day.DayNumber]"><i class="modus-icons">clipboard_planning</i></button>
                                                        </td>
                                                    </tr>
                                                    <ng-container *ngFor="let timeWorkedSequence of timeWorked">
                                                        <!-- Start Hour -->
                                                        <tr>
                                                            <td>Start:</td>
                                                            <td *ngFor="let day of daysOfWeek">
                                                                <div style="min-height: 19px;">
                                                                    <span *ngIf="!isStandardTimecard && timeWorkedSequence[day.DayNumber]?.StartTime != null">
                                                                        <a class="button-link pointer" *ngIf="timeWorkedSequence[day.DayNumber]?.StartAttachmentID != null || timeWorkedSequence[day.DayNumber]?.Notes?.length > 0" [href]="" (click)="getTimeWorkedDetails(day,timeWorkedSequence,true)">
                                                                            {{timeWorkedSequence[day.DayNumber].StartTime}}
                                                                        </a>
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StartAttachmentID == null && (timeWorkedSequence[day.DayNumber]?.Notes == null || timeWorkedSequence[day.DayNumber]?.Notes == '')">
                                                                            {{timeWorkedSequence[day.DayNumber].StartTime}}
                                                                        </span>
                                                                    </span>
                                                                    <span *ngIf="isStandardTimecard && timeWorkedSequence[day.DayNumber]?.StartTime != null">
                                                                        {{timeWorkedSequence[day.DayNumber].StartTime}}
                                                                    </span>
                                                                    <span *ngIf="!isStandardTimecard && facialRecEnabled && timeWorkedSequence[day.DayNumber]?.StartAttachmentID != null && timeWorkedSequence[day.DayNumber]?.StartTime != null">
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StartTimeConfidenceScore != null && timeWorkedSequence[day.DayNumber]?.StartTimeConfidenceScore >= facialRecThreshold">
                                                                            <i class="modus-icons align-bottom green" aria-hidden="true">check</i>
                                                                        </span>
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StartTimeConfidenceScore != null && timeWorkedSequence[day.DayNumber]?.StartTimeConfidenceScore < facialRecThreshold">
                                                                            <i class="modus-icons align-bottom red" aria-hidden="true">close</i>
                                                                        </span>
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StartTimeConfidenceScore == null"
                                                                              style="color:#ff6a00;">
                                                                            <i class="modus-icons align-bottom">clock</i>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <!-- Stop Hour -->
                                                        <tr>
                                                            <td>Stop:</td>
                                                            <td *ngFor="let day of daysOfWeek">
                                                                <div style="min-height: 19px;">
                                                                    <span *ngIf="!isStandardTimecard && timeWorkedSequence[day.DayNumber]?.StopTime != null">
                                                                        <a class="button-link pointer" *ngIf="timeWorkedSequence[day.DayNumber]?.StopAttachmentID != null || timeWorkedSequence[day.DayNumber]?.Notes?.length > 0" [href]="" (click)="getTimeWorkedDetails(day,timeWorkedSequence,false)">
                                                                            {{timeWorkedSequence[day.DayNumber]?.StopTime}}
                                                                        </a>
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StopAttachmentID == null && (timeWorkedSequence[day.DayNumber]?.Notes == null || timeWorkedSequence[day.DayNumber]?.Notes == '')">
                                                                            {{timeWorkedSequence[day.DayNumber]?.StopTime}}
                                                                        </span>
                                                                    </span>
                                                                    <span *ngIf="isStandardTimecard && timeWorkedSequence[day.DayNumber]?.StopTime != null">
                                                                        {{timeWorkedSequence[day.DayNumber]?.StopTime}}
                                                                    </span>
                                                                    <span *ngIf="!isStandardTimecard && facialRecEnabled && timeWorkedSequence[day.DayNumber]?.StopAttachmentID != null && timeWorkedSequence[day.DayNumber]?.StopTime != null">
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StopTimeConfidenceScore != null && timeWorkedSequence[day.DayNumber]?.StopTimeConfidenceScore >= facialRecThreshold">
                                                                            <i class="modus-icons align-bottom green" aria-hidden="true">check</i>
                                                                        </span>
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StopTimeConfidenceScore != null && timeWorkedSequence[day.DayNumber]?.StopTimeConfidenceScore < facialRecThreshold">
                                                                            <i class="modus-icons align-bottom red" aria-hidden="true">close</i>
                                                                        </span>
                                                                        <span *ngIf="timeWorkedSequence[day.DayNumber]?.StopTimeConfidenceScore == null"
                                                                              style="color:#ff6a00;">
                                                                            <i class="modus-icons align-bottom">clock</i>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <!-- Break Hours -->
                                                        <tr *ngIf="!isStandardTimecard || showBreakHours">
                                                            <td>Break Hours:</td>
                                                            <td *ngFor="let day of daysOfWeek">
                                                                <div style="min-height: 19px;">
                                                                    <span *ngIf="timeWorkedSequence[day.DayNumber]?.BreakHours != null">
                                                                        {{timeWorkedSequence[day.DayNumber]?.BreakHours}}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <!-- Subtotal -->
                                                    <tr *ngIf="timeWorkedSubTotals != null">
                                                        <td>Subtotal:</td>
                                                        <td *ngFor="let day of daysOfWeek">
                                                            {{timeWorkedSubTotals[day.DayNumber]?.Subtotal}}
                                                            <ng-template #popContent><div [innerHtml]="timeWorkedSubTotals[day.DayNumber]?.Text"></div></ng-template>
                                                            <span *ngIf="timeWorkedSubTotals[day.DayNumber]?.Difference != 0" class="btn"
                                                                  [ngClass]="{'btn-outline-dark' : timeWorkedSubTotals[day.DayNumber]?.DifferenceAbs <= gpsClockInFaultTolerance, 'btn-danger' : timeWorkedSubTotals[day.DayNumber]?.DifferenceAbs > gpsClockInFaultTolerance }"
                                                                  [ngbPopover]="popContent"
                                                                  [autoClose]="'inside'">
                                                                ({{timeWorkedSubTotals[day.DayNumber]?.Difference}})
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!--Mobile Time In/Out-->
                                        <div class="row d-block d-md-none" *ngIf="dailyTimeLoaded && selectedDay!= null">
                                            <div class="col-sm-12" style="margin-top: 12px;">
                                                <div class="d-flex">
                                                    <div class="col-md-2 col-sm-2" *ngIf="isStandardTimecard">
                                                        <label><strong>Notes:</strong></label>
                                                    </div>
                                                    <div class="col-md-3 col-sm-3">
                                                        <label><strong>Start:</strong></label>
                                                    </div>
                                                    <div class="col-md-3 col-sm-3">
                                                        <label><strong>Stop:</strong></label>
                                                    </div>
                                                    <div class="col-md-4 col-sm-4" *ngIf="!isStandardTimecard || showBreakHours">
                                                        <label><strong>Break Hours:</strong></label>
                                                    </div>
                                                </div>
                                                <hr style="margin-top:0; margin-bottom:0;" />
                                                <div class="d-flex" style="margin-top: 12px;"
                                                     *ngFor="let sequence of timeWorked">
                                                    <div class="col-md-2 col-sm-2" *ngIf="isStandardTimecard">
                                                        <button type="button" class="btn btn-outline-dark btn-icon-only" (click)="getNotes(selectedDay,true)" [disabled]="!hasTime[selectedDay.DayNumber]"><i class="modus-icons">clipboard_planning</i></button>
                                                    </div>
                                                    <div class="col-md-3 col-sm-3">
                                                        <span *ngIf="!isStandardTimecard">
                                                            <a [href]="" class="button-link pointer" (click)="getTimeWorkedDetails(selectedDay,sequence,true)">
                                                                {{sequence[selectedDay.DayNumber]?.StartTime}}
                                                            </a>
                                                        </span>
                                                        <span *ngIf="isStandardTimecard">
                                                            {{sequence[selectedDay.DayNumber]?.StartTime}}
                                                        </span>
                                                    </div>
                                                    <div class="col-md-3 col-sm-3">
                                                        <span *ngIf="!isStandardTimecard">
                                                            <a [href]="" class="button-link pointer" (click)="getTimeWorkedDetails(selectedDay,sequence,false)">
                                                                {{sequence[selectedDay.DayNumber]?.StopTime}}
                                                            </a>
                                                        </span>
                                                        <span *ngIf="isStandardTimecard">
                                                            {{sequence[selectedDay.DayNumber]?.StopTime}}
                                                        </span>
                                                    </div>
                                                    <div class="col-md-4 col-sm-4" *ngIf="!isStandardTimecard || showBreakHours">
                                                        <span>
                                                            {{sequence[selectedDay.DayNumber]?.BreakHours}}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="d-block d-sm-none" style="margin-top:12px;">
                                                    <label><strong>Subtotal:</strong></label> {{timeWorkedSubTotals[selectedDay?.DayNumber]?.Subtotal}}
                                                    <ng-template #popContent><div [innerHtml]="timeWorkedSubTotals[selectedDay?.DayNumber]?.Text"></div></ng-template>
                                                    <span *ngIf="timeWorkedSubTotals[selectedDay?.DayNumber]?.Difference != 0" class="btn"
                                                          [ngClass]="{'btn-outline-dark' : timeWorkedSubTotals[selectedDay?.DayNumber]?.DifferenceAbs <= gpsClockInFaultTolerance, 'btn-danger' : timeWorkedSubTotals[selectedDay?.DayNumber]?.DifferenceAbs > gpsClockInFaultTolerance }"
                                                          [ngbPopover]="popContent"
                                                          [autoClose]="'inside'">
                                                        ({{timeWorkedSubTotals[selectedDay?.DayNumber]?.Difference}})
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Clock In/ Clock Out Location Analysis -->
            <div id="reviewLocation" class="card border mb-3" *ngIf="showMap && mapPoints.length > 0">
                <div class="large-heading card-header bg-light pointer" (click)="collapseReviewLocation()">
                    <i class="modus-icons align-bottom" *ngIf="reviewLocationCollapsed" aria-hidden="true">chevron_right</i>
                    <i class="modus-icons align-bottom" *ngIf="!reviewLocationCollapsed" aria-hidden="true">expand_more</i>
                    Clock In / Clock Out Location Analysis
                </div>
                <div class="card-body" [hidden]="reviewLocationCollapsed">
                    <div *ngIf="showMap && mapPoints.length > 0" class="row">
                        <div class="col-lg-8">
                            <div class="card border" style="border-bottom: none; margin-bottom: 3px;">
                                <div class="card-header bg-light">
                                    <div style="display:inline-block; padding:6px 12px; font-weight:bold;">Legend:</div>
                                    <div style="display: inline-block; margin-right: 16px;">
                                        <img style="height:32px; " src="https://www.google.com/intl/en_us/mapfiles/ms/micons/green-dot.png" alt="Green Dot" />
                                        Clocked In
                                    </div>
                                    <div style="display: inline-block; margin-right: 16px;">
                                        <img style="height:32px; " src="https://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png" alt="Red Dot" />
                                        Clocked Out
                                    </div>
                                    <div style="display: inline-block; margin-right: 16px;">
                                        <img style="height:32px; " src="https://www.google.com/intl/en_us/mapfiles/ms/micons/yellow-dot.png" alt="Yellow Dot" />
                                        Job Site
                                    </div>
                                    <button type="button" class="btn btn-outline-dark" (click)="mapAllPoints()">
                                        Show All
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 d-none d-md-block">
                            <div role="alert" class="alert alert-warning">Click a line below to see the location.</div>
                        </div>
                    </div>
                    <div *ngIf="showMap && mapPoints.length > 0" class="row">
                        <div class="col-lg-8">
                            <div #mapDiv id="map" style="height:300px;"></div>
                        </div>
                        <div class="col-md-12 d-block d-md-none">
                            <div role="alert" class="alert alert-warning" style="margin-top:12px;">Click a line below to see the location.</div>
                        </div>
                        <div class="col-lg-4" style="max-height: 300px; overflow-y: auto;">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="tableHeader">Action</th>
                                        <th class="tableHeader">Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let point of filteredPoints" (click)="mapSinglePoint(point)" class="clickableRow pointer">
                                        <td>
                                            <span *ngIf="point.ClockAction">Clock In</span>
                                            <span *ngIf="!point.ClockAction">Clock Out</span>
                                        </td>
                                        <td>
                                            {{point.DisplayDate}} - {{point.DisplayTime}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Review Hours Allocated By Day -->
            <div id="reviewDaily" *ngIf="isStandardTimecard || reviewGrid.totals != null" class="card border mb-3">
                <div class="large-heading card-header bg-light pointer" (click)="reviewDailyCollapsed = !reviewDailyCollapsed">
                    <i class="modus-icons align-bottom" *ngIf="!reviewDailyCollapsed" aria-hidden="true">chevron_right</i>
                    <i class="modus-icons align-bottom" *ngIf="reviewDailyCollapsed" aria-hidden="true">expand_more</i>
                    Review Hours Allocated By Day
                </div>
                <div class="card-body" *ngIf="reviewDailyCollapsed">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="rotatedHeader"></th>
                                <th class="rotatedHeader tableHeader"><div><span>Total</span></div></th>
                                <th *ngFor="let summary of dailySummary | keyvalue" class="rotatedHeader tableHeader">
                                    <div *ngIf="summary.key != 'Total'">
                                        <span>{{summary.value.Day}}<br />{{summary.value.DisplayDate}}</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="dailySummary.Total.J != null && dailySummary.Total.J != 0">
                                <td>Job Hours</td>
                                <td>{{(dailySummary.Total.J).toFixed(2)}}</td>
                                <td *ngFor="let summary of dailySummary | keyvalue">
                                    <div *ngIf="summary.key != 'Total'">
                                        {{(summary.value.J).toFixed(2)}}
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="dailySummary.Total.O != null && dailySummary.Total.O != 0">
                                <td>{{unbilledLabel}} Hours</td>
                                <td>{{(dailySummary.Total.O).toFixed(2)}}</td>
                                <td *ngFor="let summary of dailySummary | keyvalue">
                                    <div *ngIf="summary.key != 'Total'">
                                        {{(summary.value.O).toFixed(2)}}
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="dailySummary.Total.S != null && dailySummary.Total.S > 0">
                                <td>Service Hours</td>
                                <td>{{(dailySummary.Total.S).toFixed(2)}}</td>
                                <td *ngFor="let summary of dailySummary | keyvalue">
                                    <div *ngIf="summary.key != 'Total'">
                                        {{(summary.value.S).toFixed(2)}}
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="dailySummary.Total.M != null && dailySummary.Total.M > 0">
                                <td>Mechanic Hours</td>
                                <td>{{(dailySummary.Total.M).toFixed(2)}}</td>
                                <td *ngFor="let summary of dailySummary | keyvalue">
                                    <div *ngIf="summary.key != 'Total'">
                                        {{(summary.value.M).toFixed(2)}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span style="font-weight:bold;">Total Hours</span></td>
                                <td><span style="font-weight:bold;">{{(dailySummary.Total.Total).toFixed(2)}}</span></td>
                                <td *ngFor="let summary of dailySummary | keyvalue">
                                    <div *ngIf="summary.key != 'Total'">
                                        <span style="font-weight:bold;">{{(summary.value.Total).toFixed(2)}}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="dailySummary.Total.Expenses != null && dailySummary.Total.Expenses > 0">
                                <td>Expenses</td>
                                <td>{{dailySummary.Total.Expenses | currency:currencySymbol}}</td>
                                <td *ngFor="let summary of dailySummary | keyvalue">
                                    <div *ngIf="summary.key != 'Total'">
                                        {{summary.value.Expenses | currency:currencySymbol}}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Job Line Summary -->
            <!-- Timecard Approval View && Standard Timecard View - Desktop View -->
            <div *ngIf="(!isStandardTimecard || !mobileMode)  && reviewGrid.rows['J']?.length > 0">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">Job Line Summary</div>
                    <div class="card-body" style="overflow: auto;">
                        <table class="table table-responsive-lg">
                            <thead>
                                <tr>
                                    <th *ngFor="let col of reviewGrid.columns['J']" class="tableHeader">{{col.ColumnLabel}}</th>
                                    <th *ngIf="reviewGrid.hasAttachments['J']"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of reviewGrid.rows['J']">
                                    <td *ngFor="let col of reviewGrid.columns['J']">
                                        {{row[col.ColumnName]}}
                                    </td>
                                    <td *ngIf="reviewGrid.hasAttachments['J']">
                                        <button type="button" class="btn btn-primary"
                                                (click)="addAttachments(row)"
                                                *ngIf="row.HasAttachments == '1'">
                                            <span class="oi oi-paperclip"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Standard Timecard View - Mobile View -->
            <div *ngIf="isStandardTimecard && reviewGrid.rows['J']?.length > 0 && mobileMode">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">Job Line Summary</div>
                    <div class="card-body">
                        <div *ngFor="let row of reviewGrid.rows['J']; let $index = index;" [ngClass]="{'evenrow2' : $index % 2 == 1}">
                            <div *ngFor="let col of reviewGrid.columns['J']" style="padding-top: 10px;margin-left:10px;">
                                <label><strong>{{col.ColumnLabel}}: </strong></label>
                                <span>{{row[col.ColumnName]}}</span>
                            </div>
                            <button type="button" class="btn btn-primary"
                                    style="margin-left:10px;"
                                    (click)="addAttachments(row)"
                                    *ngIf="row.HasAttachments == '1' && reviewGrid.hasAttachments['J']">
                                <span class="oi oi-paperclip"></span>
                            </button>
                            <hr style="margin:10px;" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- Service Line Summary -->
            <!-- Timecard Approval View & Standard Timecard View - Desktop View -->
            <div *ngIf="(!isStandardTimecard || !mobileMode) && reviewGrid.rows['S']?.length > 0">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">
                        Service Line Summary
                    </div>
                    <div class="card-body">
                        <table class="table table-responsive-lg">
                            <thead>
                                <tr>
                                    <th *ngFor="let col of reviewGrid.columns['S']" class="tableHeader">{{col.ColumnLabel}}</th>
                                    <th *ngIf="reviewGrid.hasAttachments['S']"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of reviewGrid.rows['S']">
                                    <td *ngFor="let col of reviewGrid.columns['S']">{{row[col.ColumnName]}}</td>
                                    <td *ngIf="reviewGrid.hasAttachments['S']">
                                        <button type="button" class="btn btn-primary"
                                                (click)="addAttachments(row)"
                                                *ngIf="row.HasAttachments == '1'">
                                            <span class="oi oi-paperclip"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Standard Timecard View - Mobile View -->
            <div *ngIf="isStandardTimecard && reviewGrid.rows['S']?.length > 0  && mobileMode">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">
                        Service Line Summary
                    </div>
                    <div class="card-body">
                        <div *ngFor="let row of reviewGrid.rows['S']; let $index = index;" [ngClass]="{'evenrow2' : $index % 2 == 1}">
                            <div *ngFor="let col of reviewGrid.columns['S']" style="padding-top: 10px;margin-left:10px;">
                                <label><strong>{{col.ColumnLabel}}: </strong></label>
                                <span>{{row[col.ColumnName]}}</span>
                            </div>
                            <button type="button" class="btn btn-primary"
                                    style="margin-left:10px;"
                                    (click)="addAttachments(row)"
                                    *ngIf="row.HasAttachments == '1' && reviewGrid.hasAttachments['S']">
                                <span class="oi oi-paperclip"></span>
                            </button>
                            <hr style="margin:10px;" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mechanics Line Summary -->
            <!-- Timecard Approval View & Standard Timecard View - Desktop View -->
            <div *ngIf="(!isStandardTimecard || !mobileMode) && reviewGrid.rows['M']?.length > 0">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">
                        Mechanics Line Summary
                    </div>
                    <div class="card-body">
                        <table class="table table-responsive-lg">
                            <thead>
                                <tr>
                                    <th *ngFor="let col of reviewGrid.columns['M']" class="tableHeader">{{col.ColumnLabel}}</th>
                                    <th *ngIf="reviewGrid.hasAttachments['M']"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of reviewGrid.rows['M']">
                                    <td *ngFor="let col of reviewGrid.columns['M']">{{row[col.ColumnName]}}</td>
                                    <td *ngIf="reviewGrid.hasAttachments['M']">
                                        <button type="button" class="btn btn-primary"
                                                (click)="addAttachments(row)"
                                                *ngIf="row.HasAttachments == '1'">
                                            <span class="oi oi-paperclip"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Standard Timecard View - Mobile View -->
            <div *ngIf="isStandardTimecard && reviewGrid.rows['M']?.length > 0  && mobileMode">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">
                        Mechanics Line Summary
                    </div>
                    <div class="card-body">
                        <div *ngFor="let row of reviewGrid.rows['M']; let $index = index;" [ngClass]="{'evenrow2' : $index % 2 == 1}">
                            <div *ngFor="let col of reviewGrid.columns['M']" style="padding-top: 10px;margin-left:10px;">
                                <label><strong>{{col.ColumnLabel}}: </strong></label>
                                <span>{{row[col.ColumnName]}}</span>
                            </div>
                            <button type="button" class="btn btn-primary"
                                    style="margin-left:10px;"
                                    (click)="addAttachments(row)"
                                    *ngIf="row.HasAttachments == '1' && reviewGrid.hasAttachments['M']">
                                <span class="oi oi-paperclip"></span>
                            </button>
                            <hr style="margin:10px;" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- OT Line Summary -->
            <!-- Timecard Approval View & Standard Timecard - Desktop View  -->
            <div *ngIf="(!isStandardTimecard || !mobileMode) && reviewGrid.rows['O']?.length > 0">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">
                        {{unbilledLabel}} Line Summary
                    </div>
                    <div class="card-body">
                        <table class="table table-responsive-lg">
                            <thead>
                                <tr>
                                    <th *ngFor="let col of reviewGrid.columns['O']" class="tableHeader">{{col.ColumnLabel}}</th>
                                    <th *ngIf="reviewGrid.hasAttachments['O']"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of reviewGrid.rows['O']">
                                    <td *ngFor="let col of reviewGrid.columns['O']">{{row[col.ColumnName]}}</td>
                                    <td *ngIf="reviewGrid.hasAttachments['O']">
                                        <button type="button" class="btn btn-primary"
                                                (click)="addAttachments(row)"
                                                *ngIf="row.HasAttachments == '1'">
                                            <span class="oi oi-paperclip"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Standard Timecard - Mobile View -->
            <div *ngIf="isStandardTimecard && reviewGrid.rows['O']?.length > 0  && mobileMode">
                <div class="card border mb-3">
                    <div class="large-heading card-header bg-light">
                        {{unbilledLabel}} Line Summary
                    </div>
                    <div class="card-body">
                        <div *ngFor="let row of reviewGrid.rows['O']; let $index = index;" [ngClass]="{'evenrow2' : $index % 2 == 1}">
                            <div *ngFor="let col of reviewGrid.columns['O']" style="padding-top: 10px;margin-left:10px;">
                                <label><strong>{{col.ColumnLabel}}: </strong></label>
                                <span>{{row[col.ColumnName]}}</span>
                            </div>
                            <button type="button" class="btn btn-primary"
                                    style="margin-left:10px;"
                                    (click)="addAttachments(row)"
                                    *ngIf="row.HasAttachments == '1' && reviewGrid.hasAttachments['O']">
                                <span class="oi oi-paperclip"></span>
                            </button>
                            <hr style="margin:10px;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Signature Panel -->
    <div class="card border mb-3" *ngIf="isStandardTimecard && requireSign && employeeInfo.PREHKeyID == pREHKeyID && reviewGrid.action == 'submit'">
        <div class="card-header bg-light">
            <div [innerHtml]="submissionValidationMsg"></div>
        </div>
        <div class="card-body">
            <div style="margin-bottom:10px; margin-top:10px;">
                <input name="submitIssuesYes" [(ngModel)]="reviewGrid.submitNoIssues" type="radio" [value]="true" /> Yes, I Confirm
                <input name="submitIssuesNo" [(ngModel)]="reviewGrid.submitNoIssues" type="radio" [value]="false" style="margin-left:10px;" /> No (Explain)
            </div>
            <textarea name="submitIIssuesNotes" class="form-control" rows="3" [hidden]="reviewGrid.submitNoIssues == null || reviewGrid.submitNoIssues" [(ngModel)]="reviewGrid.submitIssuesNotes" placeholder="{{placesHolderMsg}}"></textarea>
        </div>
    </div>
    <div class="card mb-3" *ngIf="isStandardTimecard && requireSign && employeeInfo.PREHKeyID == pREHKeyID && reviewGrid.action == 'submit'" style="overflow-x: auto;">
        <div class="card-body" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;" [ngStyle]="{width: panelWidth + 'px'}">
            <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
            <div class="m-signature-pad" style="margin-top:20px;">
                <div class="m-signature-pad--body" [ngClass]="{signaturepad: redBorder == true}" [hidden]="submitSignImg != null">
                    <signature-pad [options]="signaturePadOptions" #signaturePad></signature-pad>
                </div>
                <div [hidden]="submitSignImg == null" style="background-color:white;border:1px solid black">
                    <img [src]="submitSignImg" [ngStyle]="{'max-width.px': panelWidth-50}" />
                </div>
                <div class="m-signature-pad--footer">
                    <div style="text-align: center;font-size: 14px;">Sign above</div>
                    <button type="button" class="btn btn-outline-dark" (click)="clearSignature()">Clear Signature</button>
                    <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')" *ngIf="enableCheckboxSign && !hideClick">Generate Signature</button>
                    <div class="alert alert-warning" type="warning" style="margin:10px;">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Standard Timecard Buttons -->
    <div *ngIf="isStandardTimecard">
        <button style="width:100px;" *ngIf="reviewGrid.action == 'submit' && requireSign && employeeInfo.PREHKeyID == pREHKeyID" type="button" class="btn btn-primary" (click)="submitClicked()" [disabled]="requireSign && employeeInfo.PREHKeyID && (reviewGrid.submitNoIssues == null || (!reviewGrid.submitNoIssues && (reviewGrid.submitIssuesNotes == null || reviewGrid.submitIssuesNotes == '')))">
            <span class="modus-icons align-bottom">paper_plane</span>Submit
        </button>
        <hr *ngIf="(!requireSign || employeeInfo.PREHKeyID != pREHKeyID) && reviewGrid.action == 'submit'" />
        <div *ngIf="reviewGrid.action == 'submit' && (!requireSign || employeeInfo.PREHKeyID != pREHKeyID)">
            <div class="card card-header bg-light">
                <button type="button" style="width:100px;" class="btn btn-primary" (click)="submitClicked()">
                    <span class="modus-icons align-bottom">paper_plane</span>Submit
                </button>
            </div>
        </div>
        <input type="text" class="form-control mr-1" placeholder="Memo" style="max-width:60%; display:inline"
               [(ngModel)]="reviewGrid.memo"
               *ngIf="reviewGrid.action == 'approve'" />
        <button *ngIf="reviewGrid.action == 'approve' && timecard.IsSubmitted" [disabled]="reviewGridLoading" type="button" class="btn btn-danger" (click)="rejectTimecard()">
            <i class="modus-icons align-bottom" aria-hidden="true">close</i> Reject
        </button>
        <button *ngIf="reviewGrid.action == 'approve'" [disabled]="reviewGridLoading" type="button" class="btn btn-primary" (click)="approveTimecard()">
            <i class="modus-icons align-bottom" aria-hidden="true">check</i> Approve
        </button>
    </div>

    <!-- Timecard Approve Buttons -->
    <div class="card bg-light card-sm" *ngIf="!isStandardTimecard">
        <div class="row">
            <div class="col-lg-8" *ngIf="!reviewOnly">
                <input type="text" class="form-control" placeholder="Memo"
                       [(ngModel)]="reviewGrid.memo"
                       *ngIf="reviewGrid.action == 'approve'" />
            </div>
            <div class="col-lg-4" *ngIf="!reviewOnly">
                <button *ngIf="reviewGrid.action == 'approve' && !reviewAll" [disabled]="reviewGridLoading" type="button" class="btn btn-danger" (click)="rejectTimecard()">
                    <i class="modus-icons align-bottom" aria-hidden="true">close</i> Reject
                </button>
                <button *ngIf="reviewGrid.action == 'approve'" [disabled]="reviewGridLoading" type="button" class="btn btn-primary" (click)="approveTimecard()">
                    <i class="modus-icons align-bottom" aria-hidden="true">check</i> Approve <span *ngIf="reviewAll"> {{crewTemplateList.length}} Timecards</span>
                </button>
                <button *ngIf="!reviewGridLoading" type="button" class="btn btn-outline-dark" (click)="cancelReview()">Cancel</button>
            </div>
            <div class="col-lg-12" *ngIf="reviewOnly">
                <button *ngIf="!reviewGridLoading" type="button" class="btn btn-outline-dark float-right" (click)="cancelReview()">Close</button>
            </div>
        </div>
    </div>
</div>
